import { newrelic } from "@jti/fe-clients";
import type { Order } from "@jti/magento";
import { MagentoApiClient } from "@jti/magento";
import type { MagentoApiPlaceOrderMutationResponse } from "@jti/magento-api-v2";
import type { ApiMagentoPlaceOrderMutationPayload } from "@jti/magento-types";

import { TAGS } from "../common/tags";
import type { MagentoApiBuilder } from "../magentoApiSlice";

export const placeOrderEndpoint = (builder: MagentoApiBuilder) => ({
  placeOrder: builder.mutation<Order, ApiMagentoPlaceOrderMutationPayload>({
    query: (payload) => ({
      method: "placeOrder",
      params: [payload],
    }),
    transformResponse: (response: MagentoApiPlaceOrderMutationResponse) => {
      try {
        if (!response.placeOrder?.orderV2) {
          throw new Error("PLACE_ORDER_MISSING_ORDER_V2");
        }

        return MagentoApiClient.fromMagentoOrder(response.placeOrder.orderV2 as any);
      } catch (error) {
        newrelic.noticeError(error as Error);
        throw error;
      }
    },
    invalidatesTags: [TAGS.CART_ID],
  }),
});
